"use client"

import type { Feedback } from "@stockline/shared/types/core/feedback"
import { FEEDBACK_TABLE } from "../../../lib/offline/resources/core/feedback/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export function useFeedbacks(): Feedback[] {
  const { reactive } = useAISync()
  return reactive.useQuery<Feedback>(FEEDBACK_TABLE, {
    orderBy: "-updatedAt",
  })
}

export function useFeedback(id: string | null): Feedback | null {
  const { reactive } = useAISync()
  const result = reactive.useOne<Feedback>(FEEDBACK_TABLE, id ?? "")
  return id ? result : null
}
